import axios from 'axios';

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${API_BASE}/api`, timeout: 20000 });
export const mediaUrl = path => `${API_BASE}${path}`;
export const dimensionIds = ['0d', '1d', '2d', '3d', '4d', '5d', 'nd', 'infinity'];

export function visitorId() {
  let id = localStorage.getItem('dimensions-visitor');
  if (!id) { id = crypto.randomUUID(); localStorage.setItem('dimensions-visitor', id); }
  return id;
}